import { render } from "./BaseIconFitHeight.vue?vue&type=template&id=51bf0ef3"
const script = {}

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/BaseIconFitHeight.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51bf0ef3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51bf0ef3', __exports__)) {
    console.log('reload')
    api.reload('51bf0ef3', __exports__)
  }
  
  module.hot.accept("./BaseIconFitHeight.vue?vue&type=template&id=51bf0ef3", () => {
    console.log('re-render')
    api.rerender('51bf0ef3', render)
  })

}


export default __exports__